<template>
  <div class="wrapper">
    <h3 class="font_18_black">通知提醒设置</h3>
    <div class="white_box setting">
      <div class="item">
        <div class="toggle">
          <h4 class="name font_14_black">系统消息</h4>
          <div class="toggle-button">
            <el-switch
              v-model="sysMsg"
              @change="saveSetting"
              active-color="#5c74f5"
              inactive-color="#b8bac9"
            ></el-switch>
          </div>
        </div>
        <div class="explain font_14_gray">
          <p>当系统更新时，将以站内信的形式通知</p>
        </div>
      </div>
      <div class="item">
        <div class="toggle">
          <h4 class="name font_14_black">政策公告</h4>
          <div class="toggle-button">
            <el-switch
              v-model="police"
              @change="saveSetting"
              active-color="#5c74f5"
              inactive-color="#b8bac9"
            ></el-switch>
          </div>
        </div>
        <div class="explain font_14_gray">
          <p>各城市新增的政策公告，将以站内信的形式通知</p>
          <p class="citys">
            推送城市：{{citys.join(",")}}
            <span
              class="city-setting font_14_orange"
              @click="setting_mask = true"
            >设置</span>
          </p>
        </div>
      </div>
      <div class="item">
        <div class="toggle">
          <h4 class="name font_14_black">协议到期</h4>
          <div class="toggle-button">
            <el-switch
              v-model="contract"
              @change="saveSetting"
              active-color="#5c74f5"
              inactive-color="#b8bac9"
            ></el-switch>
          </div>
        </div>
        <div class="explain font_14_gray">
          <p>与泛亚协议到期的前30天、前15天、前7天、前3天、到期当天，将以站内信的形式通知</p>
        </div>
      </div>
      <div class="item">
        <div class="toggle">
          <h4 class="name font_14_black">员工合同到期</h4>
          <div class="toggle-button">
            <el-switch
              v-model="employee"
              @change="saveSetting"
              active-color="#5c74f5"
              inactive-color="#b8bac9"
            ></el-switch>
          </div>
        </div>
        <div class="explain font_14_gray">
          <p>员工合同到期且未续签的，合同到期的前30天、前15天、前7天、前3天、到期当天，将以站内信的形式通知</p>
        </div>
      </div>
      <div class="item">
        <div class="toggle">
          <h4 class="name font_14_black">报表生成</h4>
          <div class="toggle-button">
            <el-switch
              v-model="report"
              @change="saveSetting"
              active-color="#5c74f5"
              inactive-color="#b8bac9"
            ></el-switch>
          </div>
        </div>
        <div class="explain font_14_gray">
          <p>每月用工数据报表、社保数据报表、薪酬数据报表生成时，将以站内信的形式通知</p>
        </div>
      </div>
    </div>
 
    <!-- 推送城市设置 -->
    <el-dialog title="推送城市设置" :visible.sync="setting_mask" width="600px" center>
      <div class="transfer">
        <el-transfer
          v-model="value"
          :data="cityData"
          filterable
          :format="{noChecked: ' ', hasChecked: ' '}"
          :render-content="renderFunc"
          :titles="['请选择推送的城市', '已选择城市']"
          :button-texts="['到左侧', '到右侧']"
          @change="handleChange"
        >
        </el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a
            padding="10px 124px"
            color="#fff"
            bgcolor="#5c74f5"
            @click.native="saveSetting()"
          >保存</button-a>
        </div>
      </span>
    </el-dialog>

    <!-- 操作成功 -->
    <el-dialog title :visible.sync="success_mask" width="18%" center>
      <div class="success_icon">
        <img src="@/assets/icons/check002-E007@2x.png" alt />
      </div>
      <h3 class="export-title font_16_black" style="margin-bottom: 0;">修改成功</h3>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a
            padding="10px 54px"
            color="#fff"
            bgcolor="#f26828"
            @click.native="success_mask = false"
          >确定</button-a>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get,Put } from "@/js/http.js";
// import qs from "qs";
// import axios from "axios";

export default {
  components: {},
  props: {},
  data() {
    return {
      sysMsg: false, // 系统消息
      police: false, // 政策公告
      contract: false, // 协议到期
      employee: false, // 员工合同到期
      report: false, // 报表生成
      citys: [], // 政策公告的城市
      cityList: [],

      cityData: [],
      value: [],
      renderFunc(h, option) {
        return <span>{option.label}</span>;
      },
      setting_mask: false, // 推送城市设置框遮罩
      success_mask: false // 操作成功提示
    };
  },
  watch: {},
  computed: {
    // 要发送的数据
    configDtos() {
      return [
        {
          messageType: 1,
          isSend: this.sysMsg,
          remark: ""
        },
        {
          messageType: 2,
          isSend: this.police,
          remark: this.value.join(",")
        },
        {
          messageType: 3,
          isSend: this.contract,
          remark: ""
        },
        {
          messageType: 4,
          isSend: this.employee,
          remark: ""
        },
        {
          messageType: 5,
          isSend: this.report,
          remark: ""
        }
      ];
    }
  },
  methods: {
    // 获取当前设置
    getSetting() {
      Get("api/v1/message-configs").then(res => {
        let data = res.data;
        this.sysMsg = data.find(item => item.messageType === 1).isSend;
        this.police = data.find(item => item.messageType === 2).isSend;
        this.citys = data
          .find(item => item.messageType === 2)
          .remark.split(",");
        // this.value = data.find(item => item.messageType === 2).remark.split(',');
        this.contract = data.find(item => item.messageType === 3).isSend;
        this.employee = data.find(item => item.messageType === 4).isSend;
        this.report = data.find(item => item.messageType === 5).isSend;
        this.getCityOption();
      });
    },
    // 获取城市选项
    getCityOption() {
      Get("api/v1/message-configs/cities", {
        checkedNames: this.citys.join(",")
      }).then(res => {
        let data = res.data;
        // 可选的城市
        this.cityData = data.map(item => {
          return {
            key: item.label,
            label: item.label
          };
        });
        // 已选择的城市
        this.value = data.filter(item => item.selected).map(item => item.label);
      });
    },
    toggleSwitch() {},
    // 保存设置
    saveSetting() {
      Put(
        "api/v1/message-configs",
        {
          // headers: {
          //   "Content-Type": "application/json"
          // },
          data: this.configDtos
        },
        {}
      )
        .then(() => {
          this.setting_mask = false;
          this.success_mask = true;
          this.getSetting();
        })
        .catch(() => {
          // this.getSetting();
        });
    },
    handleChange() {}
    // handleChange(value, direction, movedKeys) {
    // }
  },
  created() {},
  mounted() {
    this.getSetting();
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  h3 {
    margin: 22px 30px;
  }
  .setting {
    margin: 0 32px 32px 32px;
    padding: 27px 104px;
    .item {
      padding-bottom: 24px;
      border-bottom: 1px solid #e5e5e5;
      .toggle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
        }
        .toggle-button {
        }
      }
      .explain {
      }
      .citys {
        margin-top: 30px;
      }
    }
  }
}
.city-setting {
  cursor: pointer;
}
.transfer {
  width: 100%;
  min-width: 500px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

::v-deep .el-transfer {
  width: auto !important;
  min-width: 500px !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  box-sizing: border-box;
}

::v-deep .el-transfer__panel {
  flex: 1 !important;
  min-width: 220px !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
}

::v-deep .el-transfer__buttons {
  flex-shrink: 0 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
  gap: 10px !important;
  padding: 0 10px !important;
  margin: 0 !important;
  box-sizing: border-box;
}

::v-deep .el-transfer__buttons .el-button {
  margin: 0 !important;
  margin-bottom: 0 !important;
  box-sizing: border-box;
}

::v-deep .el-transfer-panel {
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
}

::v-deep .el-dialog__body {
  padding: 20px !important;
  box-sizing: border-box;
}
::v-deep
  .el-transfer-panel
  .el-transfer-panel__header
  .el-checkbox
  .el-checkbox__label {
  font-size: 14px;
  color: #000;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #5c74f5;
}
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #5c74f5;
}
::v-deep .el-transfer__button {
  background-color: #5c74f5;
}
::v-deep .el-switch__core {
  width: 40px !important;
}
.el-transfer__buttons{
  display: flex;
}
</style>